/**
 * 车辆上架审核
 */
import React from 'react';
import { Row, Col, DatePicker, Input,Select, InputNumber } from 'antd';
import PageLayout from '../../ui/PageLayout';
//加载中遮罩
import Loading from '../../ui/Loading';
import DictSelect from '../../ui/DictSelect';

//商户选择
import MemberSelect from '../../crm/member/MemberSelect';
import messager from '../../ui/messager';


class MallStockQueryIndex extends React.Component {

    columns = [{
        title: '商户',
        dataIndex: 'memberName',
        width: '20%',
    }
    , {
        title: '品牌',
        dataIndex: 'brand',
        width: '12%',
    }
    , {
        title: '车型',
        dataIndex: 'typeName',
        width: '12%',
    }
    , {
        title: '初登日期',
        dataIndex: 'registerDate',
        width: '10%',
    }
    , {
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    }
    , {
        title: '能源类型',
        dataIndex: 'newEnergy',
        width: '8%',
        render: (text, record, index) => (
            text === 1 ? "新能源" : "汽油"
        )
    }
    , {
        title: '售价',
        dataIndex: 'price',
        width: '6%',
    }
    , {
        title: '入库时间',
        dataIndex: 'entryTime',
        width: '15%',
    }
    , {
        title: '出库时间',
        dataIndex: 'leaveTime',
        width: '15%',
    }
    , {
        title: '是否在商城',
        dataIndex: 'inPark',
        width: '8%',
        render: (text, record, index) => (
            text === true ? "是" : "否"
        )
    }
    , {
        title: '检测报告',
        dataIndex: 'checkReport',
        width: '8%',
        render: (text, record, index) => (
            text !== ""&&text !== null ? "是" : "否"
        )
    }
    , {
        title: '状态',
        dataIndex: 'statusStr',
        width: '10%',
    }
];

    state = {
        visible: false,
        loadData: '',
        queryData: {},
        loadingVisible: false
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.inTimeStart = dateStrings[0];
        queryData.inTimeEnd = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (field,value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.keywords = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputNumberChange = (field, value) => {
        if(isNaN(Number(value))){
            messager.notify("请输入数字");
            return
        }
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车辆关键字或车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '150px' }} />
                                <MemberSelect mall={1} allowClear={true} placeholder="商户" onChange={this.memberSelect} style={{ width: '150px', margin: '0 10px' }} />
                                <DictSelect category="fuelType" allowClear={true} placeholder='能源类型' onChange={this.onSelect.bind(this,"newEnergy")} style={{ width: '120px', margin: '0 10px' }} />
                                <Select placeholder="是否在商城" allowClear={true} style={{ width: 150 }} onChange={this.selectChange.bind(this, "location")}>
                                    <Select.Option value="1">是</Select.Option>
                                    <Select.Option value="0">否</Select.Option>
                                </Select>
                                <DictSelect category="MALL_VEHICLE_STATUS" allowClear={true} placeholder='状态' onChange={this.onSelect.bind(this,"status")} style={{ width: '120px', margin: '0 10px' }} />
                                <DatePicker.RangePicker style={{ width: '200px'}} placeholder={["入库","时间"]} onChange={this.rangePickerChange} />
                                <InputNumber
                                    placeholder='最低价'
                                    precision={1} 
                                    onChange={this.inputNumberChange.bind(this, "priceMin")}
                                    style={{ width: '100px',marginLeft: '10px' }} />~
                                <InputNumber
                                    placeholder='最高价'
                                    precision={1}
                                    onChange={this.inputNumberChange.bind(this, "PriceMax")}
                                    style={{ width: '100px' }} />
                                <InputNumber
                                    placeholder='最低库龄'
                                    precision={0}
                                    onChange={this.inputNumberChange.bind(this, "stockAgeMin")}
                                    style={{ width: '100px',marginLeft:'10px' }} />~
                                <InputNumber
                                    placeholder='最高库龄'
                                    precision={0}
                                    onChange={this.inputNumberChange.bind(this, "stockAgeMax")}
                                    style={{ width: '100px' }} />                                         
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/vehicleInfo/analysis/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中..."
                />
            </div>
        )
    }
}

export default MallStockQueryIndex;